import { render, staticRenderFns } from "./InviteFriendBaner.vue?vue&type=template&id=7e41796e&"
import script from "./InviteFriendBaner.vue?vue&type=script&lang=js&"
export * from "./InviteFriendBaner.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriendBaner.vue?vue&type=style&index=0&id=7e41796e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
